import clsx from 'clsx';
import { forwardRef, type ReactNode } from 'react';

import { navigationWrapperCSS } from './TitleBar.sty.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';


//#region Typings
/**
 * Accepted properties for the TitleBar Navigation
 * @public
 */
export interface TitleBarNavigationProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Navigation slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Navigation component
 * @public
 */
export const Navigation = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  TitleBarNavigationProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: TitleBarNavigationProps = props;

  return (
    <div
      ref={forwardedRef}
      className={clsx(navigationWrapperCSS, consumerClassName)}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
});
